import { customType } from 'drizzle-orm/sqlite-core'
import { z } from 'zod'

/** How multiple playlist assignments combine at a schedule root (legacy “campaign” row / playlist doc). */
export enum PlaybackMode {
  Rotating = 'rotating',
  Random = 'random'
}

const legacyPlaybackModeLiterals = ['sequential', 'interleave', 'interpolate', 'custom'] as const

/** Zod enum for persisted / API payloads (only `rotating` and `random`). */
export const playbackModeSchema = z.nativeEnum(PlaybackMode)

/**
 * Accepts stored playlist JSON or API payloads that may still carry pre–#360 values; maps them to {@link PlaybackMode.Rotating}.
 */
export const playbackModeCoercedSchema = z
  .union([playbackModeSchema, z.enum(legacyPlaybackModeLiterals)])
  .transform((v): PlaybackMode => (v === PlaybackMode.Random ? PlaybackMode.Random : PlaybackMode.Rotating))

export function coercePlaybackMode(value: unknown): PlaybackMode {
  const r = playbackModeCoercedSchema.safeParse(value)
  return r.success ? r.data : PlaybackMode.Rotating
}

export const playbackModeType = customType<{ data: PlaybackMode, notNull: true, default: true }>({
  dataType() {
    return 'text'
  },
  fromDriver(value) {
    if (typeof value === 'string') {
      const parsed = playbackModeCoercedSchema.safeParse(value)
      if (parsed.success) {
        return parsed.data
      }
    }
    throw new Error(`Invalid playback mode: ${String(value)}`)
  }
})
